if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            this.refreshCartIconBubble(response);
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.renderCartContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.renderCartContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    renderCartContents(response) {
      try {
        this.cart.renderContents(response);
      } catch (error) {
        console.error(error);
      } finally {
        this.refreshCartIconBubble(response);
      }
    }

    refreshCartIconBubble(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (!cartIconBubble) return;

      const sectionHTML = response && response.sections && response.sections['cart-icon-bubble'];

      if (sectionHTML) {
        const parsedSection = new DOMParser().parseFromString(sectionHTML, 'text/html');
        const renderedBubble = parsedSection.querySelector('.shopify-section');

        if (renderedBubble) {
          cartIconBubble.innerHTML = renderedBubble.innerHTML;
          return;
        }
      }

      fetch(`${routes.cart_url}.js`)
        .then((cartResponse) => cartResponse.json())
        .then((cart) => {
          let countBubble = cartIconBubble.querySelector('.cart-count-bubble');

          if (cart.item_count === 0) {
            if (countBubble) countBubble.remove();
            return;
          }

          if (!countBubble) {
            countBubble = document.createElement('div');
            countBubble.className = 'cart-count-bubble';
            cartIconBubble.appendChild(countBubble);
          }

          const displayCount = cart.item_count < 100 ? cart.item_count : '';
          countBubble.innerHTML = `
            ${displayCount !== '' ? `<span aria-hidden="true">${displayCount}</span>` : ''}
            <span class="visually-hidden">${this.getCartCountText(cart.item_count, countBubble)}</span>
          `;
        })
        .catch(() => {});
    }

    getCartCountText(itemCount, countBubble) {
      const existingText = countBubble && countBubble.querySelector('.visually-hidden') &&
        countBubble.querySelector('.visually-hidden').textContent.trim();

      if (existingText && /\d+/.test(existingText)) {
        return existingText.replace(/\d+/, itemCount);
      }

      const locale = (document.documentElement.lang || (window.Shopify && Shopify.locale) || 'de').slice(0, 2).toLowerCase();

      if (locale === 'en') {
        return itemCount === 1 ? '1 item' : `${itemCount} items`;
      }

      if (locale === 'es') {
        return itemCount === 1 ? '1 artículo' : `${itemCount} artículos`;
      }

      return itemCount === 1 ? '1 Artikel' : `${itemCount} Artikel`;
    }
  });
}
